module.exports = __webpack_public_path__ + "static/media/MSG91logo.fbd4268c.png";